export default "__VITE_ASSET__BTF2pgi0__"